"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgBankMaskan = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("title", null, "Bank/Color/Maskan"),
        React.createElement("desc", null, "\n    Created with Sketch.\n  "),
        React.createElement("g", { id: "Ready-For-Export", transform: "scale(.5)", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "Artboard", transform: "translate(-1848,-80)", fill: "#ec520d" },
                React.createElement("g", { id: "Banks_(Color)", transform: "translate(80,80)" },
                    React.createElement("g", { id: "Bank-/-Maskan-/-Color", transform: "translate(1768)" },
                        React.createElement("path", { id: "Shape", d: "m0 48h48v-48h-48zm6.858-6.8581h34.284v-34.287h-34.284zm32.964-10.287v-7.383l-15.822-6.33-15.822 6.33v7.383l15.822-6.327z" }))))))));
exports.default = SvgBankMaskan;
//# sourceMappingURL=BankMaskan.js.map